import React, { useState, useEffect, useRef } from "react";
import { MdOutlineEnergySavingsLeaf, MdEmojiEvents } from "react-icons/md";
import { FaHandHoldingWater, FaSchool, FaDownload, FaPeopleCarry, FaFilter } from "react-icons/fa";
import { TbVaccineBottleOff } from "react-icons/tb";
import { IoFastFood, IoMan } from "react-icons/io5";
import { FaBoxesPacking, FaBox } from "react-icons/fa6";
import { GiTeacher } from "react-icons/gi";
import { IoMdArrowRoundBack } from "react-icons/io";
import { Link, useNavigate, useLocation } from "react-router-dom";
import axiosConn from "config/axiosConn";
import { Card, CardHeader, CardBody, CardFooter, CardTitle, Row, Col } from "reactstrap";
import { Container, Image, Button, Form, Table } from "react-bootstrap";
import subThemes from "helper/SubThemes_List";
import ThemeBaseRouting from "helper/ThemeBaseRouting";
import StateList from "../../../helper/State_List.json";
import DistrictList from "../../../helper/District_List.json";
import Helper from "../../../helper/Common_Helper"
import ApexChartMonthWise from "./ApexChartMonthWise";
import ApexChartQuarterWise from "./ApexChartQuarterWise";
// import healthy from "../../../assets/images/ekped.png";
import HeaderAdmin from "../../HeaderAdmin";
import { toast } from "react-toastify";
import CircleChartTrees from "./piechartTrees.jsx";
import { FaAngleDown } from "react-icons/fa6";
import { FcCollaboration } from "react-icons/fc";
import DynamicCount from "../../../helper/AutoMation";
import LineChartTrees from "./LineChart3.jsx";
import ApexChartHeatmap from './ApexHeatChart3';
import ApexChartHeatmap2 from './ApexHeatChart4';
import BarChartsTrees from "./BarChartTrees";
import TreeIcon from "../../../assets/images/tree-icon.png";
import WardIcon from "../../../assets/images/total-ward.png";
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import html2canvas from 'html2canvas';
import { IoMdRefreshCircle } from "react-icons/io";
import * as XLSX from 'xlsx';
import { IoMdNotificationsOutline } from "react-icons/io";


function Ekpedmaakenaam() {
    const navigate = useNavigate();
    const location = useLocation();
    const dropdownRef = useRef(null);
    const [apiData, setApiData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [isFilterShow, setIsFilterShow] = useState(false);
    const [filterDistrict, setFilterDistrict] = useState([]);
    const [filteredSchool, setFilteredSchool] = useState([]);
    const [stateID, setStateID] = useState('');
    const [selectYear, setYear] = useState('');
    const [chartStatus, setChartStatus] = useState(1);
    const [timeFilter, setTimeFilter] = useState(false);
    const [quickNum, setQuickNum] = useState("");
    const [selectedDuration, setSelectedDuration] = useState("");
    const [notificationCount, setNotificationCount] = useState(0);
    const [downloadingReport, setDownloadingReport] = useState(false);
    
    const stateNames = location.state?.stateValue;

  if (stateNames) {
    localStorage.setItem("filterDataState", stateNames);
  }
    const [filterData, setFilterData] = useState({
        state: stateNames,
        district: "",
        school_name: "",
        theme_name: "",
        sub_themes: "",
        implemnt_mode: "",
        event_type: "",
        fromDate: "",
        toDate: ""
    });
    const [districtArray, setDistrictArray] = useState([]);

    // Fetch API data on mount or when filterData.state changes
    useEffect(() => {
        setLoading(true);
        setError(null);
        fetch('https://ecoclubs.education.gov.in/api/ekped-allrecords', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ state: localStorage.getItem("filterDataState") || filterData.state}),
        })
            .then(res => res.json())
            .then(data => {
                console.log("API response:", data);
                if (data.status === "success") {
                  console.log("data2", data) 
                    setApiData(data);
                    setDistrictArray(parseDistrictData(data));
                } else {
                    setError('Failed to fetch data');
                }
                setLoading(false);
            })
            .catch(err => {
                console.error("Fetch error:", err);
                setError('Failed to fetch data');
                setLoading(false);
            });
    }, [filterData.state]);

    // Add useEffect to fetch notification count when component mounts
    useEffect(() => {
        fetchNotificationCount();
    }, [stateNames]);

    const fetchNotificationCount = async () => {
        try {
            const response = await fetch('https://ecoclubs.education.gov.in/api/school-notifications/count', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ 
                    state: stateNames || localStorage.getItem("filterDataState")
                }),
            });
            const data = await response.json();
            if (data.status === "success") {
                setNotificationCount(data.count);
            }
        } catch (error) {
            console.error("Error fetching notification count:", error);
            toast.error("Failed to fetch notification count");
        }
    };

    // Other useEffect hooks (move here, before any return)
    useEffect(() => {
        // getdistrictWiseData();
        // getDistrictWiseStats(filterData.state, filterData.district);
        // getQuarterAndMonthWiseData(filterData.state, filterData.district);
    },  [filterData.state, filterData.district]);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setTimeFilter(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);
    const parseDistrictData = (data) => {
  return Object.keys(data)
    // Filter out non-numeric keys (like status, totalTrees, totalSchools)
    .filter(key => !isNaN(Number(key)))
    // Map numeric keys to their corresponding data objects
    .map(key => data[key])
    // Sort by district name (assuming each object has a `districtName` property)
    .sort((a, b) => a.district.localeCompare(b.district));
};

    

    // Derived values from API data
    const treesCount = apiData?.totalTrees || 0;
    const certificatesCount = apiData?.treesPlanted || 0;
    const participantsCount = apiData?.treesPlanted || 0;
    const schoolsCount = apiData?.totalSchools || 0;
    const blockNames = apiData?.districts?.map(d => d.district) || [];
    const stateWiseDataTrees = apiData?.districts || [];
    const statetopass=localStorage.getItem('filterDataState');
    

    // Place loading/error checks after all hooks
    if (loading) {
        return <div style={{textAlign: 'center', marginTop: 40}}><h3>Loading...</h3></div>;
    }
    

    // Placeholder for map view
    const MapView = () => (
      <div style={{ width: '100%', height: 300, background: '#e0e0e0', display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: 20 }}>
        <span style={{ color: '#888', fontWeight: 'bold' }}>[Map View Placeholder]</span>
      </div>
    );

    const handleSelectState = (data) => {
        setStateID(data);
        setFilteredSchool([])
        let StateName = StateList.find(obj => obj.state_id == data)?.state_name;
        let filterdistrictList = DistrictList.filter(obj => obj.state_id == data);
        console.log('filterdistrictList', filterdistrictList)
        setFilterDistrict(filterdistrictList);
        setFilterData(prevData => ({ ...prevData, state: StateName, district: '', school_name: "" }));
        getSchoolList({ state_id: data })
    }

    const handleSelectDistrict = async (value) => {
        setFilteredSchool([])
        setFilterData(prevData => ({ ...prevData, district: value, school_name: "" }));
        let districtid = DistrictList.find(obj => obj.district_name == value)?.district_id;
        getSchoolList({ state_id: stateID, district_id: districtid })
    }

    const handleSelectTheme = async (value) => {
        setFilterData(prevData => ({ ...prevData, theme_name: value, sub_themes: "" }));
    }

  const handleFilterChange = (field, value) => {
    if (field === "toDate") {
      setSelectedDuration(`${filterData.fromDate} to ${value}`);
      if (
        filterData?.fromDate &&
        new Date(filterData?.fromDate) > new Date(value)
      ) {
        toast.error("Start date cannot be greater than end date");
        return;
      }
    }
    setFilterData((prevData) => ({ ...prevData, [field]: value }));
    if (field === "fromDate" || field === "toDate") {
      setQuickNum("");
    }
  };

    const getSchoolList = async (data) => {
        try {
            let response = await axiosConn('post', 'get-school-filter', data)
            if (response.data.status === 'success') {
                setFilteredSchool(response.data.result)
            }
        } catch (error) {
            console.log(error);
        }
    }

    

    const handleClickFilter = (district, filter) => {
        let data = { ...filterData, district };
        data['district'] = district;

        if (filter) {
            if (filter.implemnt_mode) {
                data['implemnt_mode'] = filter.implemnt_mode;
            }
            if (filter.event_type) {
                data['event_type'] = filter.event_type;
            }
        }
        navigate("/admin/state-level/view-district-trees", { state: { state:apiData?.state , data: data } })
    }
    
    

    const applyQuickSelect = (quickSelect) => {
        const today = new Date();
        let startDate = null;
        let endDate = new Date();
    
        const quickSelectRanges = {
            last3Days: () => {
                startDate = new Date(today);
                startDate.setDate(today.getDate() - 3);
            },
            last7Days: () => {
                startDate = new Date(today);
                startDate.setDate(today.getDate() - 7);
            },
            last15Days: () => {
                startDate = new Date(today);
                startDate.setDate(today.getDate() - 15);
            },
            lastMonth: () => {
                startDate = new Date(today);
                startDate.setMonth(today.getMonth() - 1);
            },
            last3Months: () => {
                startDate = new Date(today);
                startDate.setMonth(today.getMonth() - 3);
            },
            last6Months: () => {
                startDate = new Date(today);
                startDate.setMonth(today.getMonth() - 6);
            },
            currentYear: () => {
                startDate = new Date(today.getFullYear(), 0, 1);
            },
            previousYear: () => {
                startDate = new Date(today.getFullYear() - 1, 0, 1);
                endDate = new Date(today.getFullYear() - 1, 11, 31);
            },
        };
    
        if (quickSelectRanges[quickSelect]) {
            quickSelectRanges[quickSelect]();
        } else {
            return;
        }

        setSelectedDuration(
            `${startDate.toISOString().split("T")[0]} to ${
              endDate.toISOString().split("T")[0]
            }`
          );
    
        setFilterData(prevData => ({
            ...prevData,
            fromDate: startDate.toISOString().split('T')[0],
            toDate: endDate.toISOString().split('T')[0]
        }));
        setTimeFilter(false);
    };

const handleQuickSelect = (period) => {
    applyQuickSelect(period);
};
    // Function to calculate start and end dates of the selected year
    const calculateYearRange = (year) => {
        if (!year) return { start: '', end: Helper.currentOrPastDate() };

        const startDate = `${year}-01-01`;
        const endDate = `${year}-12-31`;

        return { start: startDate, end: endDate };
    };
    // Calculate the date range for the selected year
    const { start, end } = calculateYearRange(selectYear);

const exportDashboardToPDF = async () => {
  const pdf = new jsPDF("p", "pt", "a4");
  let yPos = 20;

  // Title
  pdf.setFontSize(20);
  pdf.setTextColor("#4A4A4A");
  pdf.text("Superadmin Dashboard", 20, yPos);
  yPos += 40;

  const setSectionHeader = (text) => {
    pdf.setFontSize(16);
    pdf.setTextColor("#0080FF");
    pdf.text(text, 20, yPos);
    yPos += 30;
  };

  const addTable = (header, body) => {
    pdf.autoTable({
      startY: yPos,
      head: [header],
      body,
      theme: "grid",
      styles: { halign: "center" },
    });
    yPos = pdf.lastAutoTable.finalY + 20;
  };

  // === NEW TABLE SECTIONS ===
  setSectionHeader("District Stats");
  // Replace with your actual data
  const districtStats = [
    ["District A", 100],
    ["District B", 80],
  ];
  addTable(["District", "Event Count"], districtStats);

  setSectionHeader("Month Stats");
  const monthStats = [
    ["January", 40],
    ["February", 60],
  ];
  addTable(["Month", "Event Count"], monthStats);

  setSectionHeader("Quarter Stats");
  const quarterStats = [
    ["Q1", 0],
    ["Q2", 13],
    ["Q2", 0]
    ["Q2", 0]
  ];
  addTable(["Quarter", "Event Count"], quarterStats);

  setSectionHeader("Age Stats");
  const ageStats = [
    ["Age 3-8", 0],
    ["Age 8-11", 0],
    ["Age 11-14", 7],
    ["Age 14-18", 6],
  ];
  addTable(["Age Group", "Participants"], ageStats);

  setSectionHeader("Week Stats");
  const weekStats = [
    ["Week 1", 20],
    ["Week 2", 35],
  ];
  addTable(["Week", "Event Count"], weekStats);

  setSectionHeader("Class Stats");
  const classStats = [
    ["Class 1", 10],
    ["Class 2", 15],
    ["Class 3", 20],
  ];
  addTable(["Class", "Participants"], classStats);

  // === CHARTS SECTION ===
  const captureChart = async (classList) => {
    for (const { className, chartName } of classList) {
      const chartElement = document.querySelector(className);
      if (chartElement) {
        const canvas = await html2canvas(chartElement, {
          useCORS: true,
        });
        const imgData = canvas.toDataURL("image/png");
        const scale = 0.5;
        const imgWidth = canvas.width * scale;
        const imgHeight = canvas.height * scale;
        const pageWidth = pdf.internal.pageSize.getWidth();
        const pageHeight = pdf.internal.pageSize.getHeight();
        const margin = 20;

        if (yPos + imgHeight > pageHeight - margin) {
          pdf.addPage();
          yPos = margin;
        }

        const textWidth = pdf.getTextWidth(chartName);
        const textOffset = (pageWidth - textWidth) / 2;
        pdf.text(chartName, textOffset, yPos);
        yPos += 20;
        pdf.addImage(imgData, "PNG", margin, yPos, imgWidth, imgHeight);
        yPos += imgHeight + margin;
      }
    }
  };

  const classList = [
    { className: ".barChart", chartName: "Quarter/Month Wise Total Events" },
    { className: ".barCharts", chartName: "Month-wise Total Events" },
    { className: ".event-count-card", chartName: "Total Events Theme wise" },
    { className: ".ageChart", chartName: "Age-wise Total Events" },
    { className: ".eventTypeChart", chartName: "Event Type-wise Total Events" },
  ];

  await captureChart(classList);

  pdf.save("Admin_Dashboard.pdf");
};
















    // Export district table as PDF (with summary)
    const handleExportDistrictPDF = () => {
        const doc = new jsPDF();
        doc.setFontSize(16);
        doc.text('District-wise Stats', 14, 16);
        doc.setFontSize(12);
        doc.text(`Total Trees Planted: ${treesCount}`, 14, 26);
        doc.text(`Number of Schools Participated: ${schoolsCount}`, 14, 34);
        const tableData = districtArray.map((item, idx) => [
            idx + 1,
            item.district,
            item.studentCount,
            item.totalSchools
        ]);
        doc.autoTable({
            head: [["#", "District", "Saplings Planted", "Total Schools"]],
            body: tableData,
            startY: 40,
        });
        doc.save('District_Stats.pdf');
    };

    // Export district table as Excel (with summary)
    const handleExportDistrictExcel = () => {
        const wsData = [
            ["Total Trees Planted", treesCount],
            ["Number of Schools Participated", schoolsCount],
            [],
            ["District", "Saplings Planted", "Total Schools"],
            ...districtArray.map(item => [item.district, item.studentCount, item.totalSchools])
        ];
        const ws = XLSX.utils.aoa_to_sheet(wsData);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "District Stats");
        XLSX.writeFile(wb, 'District_Stats.xlsx');
    };

    const handleDownloadThemesReport = async () => {
        if (downloadingReport) return;
        setDownloadingReport(true);
        const toastId = toast.info("Generating Report...", { autoClose: false });

        try {
            toast.update(toastId, {
                render: "Downloading Report...",
                type: "info",
                autoClose: false
            });

            const queryParams = new URLSearchParams();
            if (filterData.fromDate) queryParams.append("fromDate", filterData.fromDate);
            if (filterData.toDate) queryParams.append("toDate", filterData.toDate);
            const response = await fetch(`https://ecoclubs.education.gov.in/api/reports/themes?${queryParams.toString()}`, {
                method: "GET",
            });

            if (!response.ok) {
                throw new Error("Failed to generate report");
            }

            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = url;
            a.download = "EcoClubs_Themes_Report.pdf";
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            window.URL.revokeObjectURL(url);

            toast.update(toastId, {
                render: "Success Message: Themes Analytics Report downloaded successfully!",
                type: "success",
                autoClose: 3000
            });
        } catch (err) {
            console.error(err);
            toast.update(toastId, {
                render: "Failed to download Themes report.",
                type: "error",
                autoClose: 3000
            });
        } finally {
            setDownloadingReport(false);
        }
    };

    return (
        <>
        <HeaderAdmin />
            <section className="scholdashbrdSec superAdminDashboardSec">
                <Container fluid>
                    <div className="dashbrdTopSrchDiv lavel mt-3 mb-1" style={{position:"relative", zIndex:999}}>
                        <h1 style={{ color: 'orange' }}>EK PED MAA KE NAAM 2.0</h1>
                        <h2>State/District <span className="hdngBrkr"> Level </span> SNAPSHOT</h2>
                        <h3 style={{letterSpacing: "0.1em"}}>Welcome State Admin- {localStorage.getItem('filterDataState')}</h3>
                        
                        <div className="text-end">
                            <Button onClick={handleDownloadThemesReport} disabled={downloadingReport} className="me-2 mt-2 mt-md-0" style={{ background: 'linear-gradient(45deg, #17a2b8, #117a8b)', border: 'none', boxShadow: '0 4px 6px rgba(0,0,0,0.1)', borderRadius: '20px', transition: 'transform 0.2s', color: 'white', fontWeight: 'bold' }}>
                                📊 Download Themes Report
                            </Button>
                            <Button onClick={handleExportDistrictPDF} className="me-2"><FaDownload size={20} color="#dddddd" /> Download PDF</Button>
                            <Button onClick={handleExportDistrictExcel} variant="success"><FaDownload size={20} color="#dddddd" /> Download Excel</Button>
                             <Button
                              className="btn btn-primary btn-sm"
                              onClick={() =>
                                (window.location.href = `https://ecoclubsmissionlife.blob.core.windows.net/ecoclubs-missionlife-container/${stateNames || localStorage.getItem("filterDataState")}.pdf?sp=r&st=2025-08-19T15:14:18Z&se=2026-12-30T23:29:18Z&spr=https&sv=2024-11-04&sr=c&sig=nZE%2BPBAMO2sKIFrNP80OjvYYY7bojSBMTvspPIPLVsg%3D`)
                              }
                            ><FaDownload size={20} color="#dddddd" /> 
                              School Wise Data PDF
                            </Button>
                            {/* const statesToProcess = ['ANDAMAN & NICOBAR ISLANDS','DADRA & NAGAR HAVELI AND DAMAN & DIU','NAGALAND','UTTARAKHAND','NAVODAYA VIDYALAYA SAMITI','ANDHRA PRADESH','ARUNACHAL PRADESH','CHANDIGARH','CHHATTISGARH','GOA','GUJARAT','HIMACHAL PRADESH','KENDRIYA VIDYALAYA SANGHATHAN','LADAKH','MIZORAM','PUDUCHERRY','RAJASTHAN','WEST BENGAL','TRIPURA',JHARKHAND
KARNATAKA
MADHYA PRADESH
TAMIL NADU] ,24.JAMMU & KASHMIR
25.MEGHALAYA
26.SIKKIM
27.BIHAR*/}

                            {
                              
                                <Button
                                  className="btn btn-primary btn-sm"
                                  onClick={() =>
                                    (window.location.href = `https://ecoclubsmissionlife.blob.core.windows.net/ecoclubs-missionlife-container/${stateNames?.toUpperCase() || localStorage.getItem("filterDataState")?.toUpperCase()}.xlsx?sp=r&st=2025-08-19T15:14:18Z&se=2026-12-30T23:29:18Z&spr=https&sv=2024-11-04&sr=c&sig=nZE%2BPBAMO2sKIFrNP80OjvYYY7bojSBMTvspPIPLVsg%3D`)
                                  }
                                >
                                  <FaDownload size={20} color="#dddddd" />
                                  Download State Wise Data Excel
                                </Button>
                              
                              
                            }
                             <Link to="/admin/environment-day-dashboard">
                                <Button className="btn-success ms-2 mt-2 mt-md-0" style={{background: 'linear-gradient(45deg, #28a745, #218838)', border: 'none', boxShadow: '0 4px 6px rgba(0,0,0,0.1)', borderRadius: '20px', transition: 'transform 0.2s'}}>
                                    <MdOutlineEnergySavingsLeaf size={20} style={{marginRight: '8px'}}/> View Environment Day Dashboard
                                </Button>
                            </Link>
                            <Link to="/admin/themes-analytics">
                                <Button className="btn-info ms-2 mt-2 mt-md-0" style={{background: 'linear-gradient(45deg, #17a2b8, #117a8b)', border: 'none', boxShadow: '0 4px 6px rgba(0,0,0,0.1)', borderRadius: '20px', transition: 'transform 0.2s', color: 'white', fontWeight: 'bold'}}>
                                    📊 View Themes Analytics Dashboard
                                </Button>
                            </Link>
                        </div>
                    </div>

                    <div className="dashbrdTopSrchDivlavel mt-2 mb-0" style={{position:"relative", zIndex:0}}>
                        <div className="d-flex justify-content-center">
                            <div className="boxdiv boxdivOne">
                                <div className="d-flex justify-content-between p-3">
                                    <div>
                                        <p> TREES <span className="text-success w100">PLANTED</span></p>
                                    </div>
                                    <img src={TreeIcon} alt="School Icon" style={{width:82, height:82}} />
                                </div>
                                <div className="d-flex justify-content-center bg-success bottomBox">
                                    <div className="bgdanger w-100">
                                        <p>TOTAL</p>
                                        <h2>{treesCount}</h2>
                                    </div>
                                </div>
                            </div>
                            <div className="boxdiv boxdivTwo">
                                <div className="d-flex justify-content-between p-3">
                                    <div >
                                        <p>NUMBER OF <span className="text-success w100">SCHOOLS PARTICIPATED</span></p>
                                    </div>
                                    <FaSchool size={82} color="#9c6829" />
                                </div>
                                <div className="d-flex justify-content-between bg-success bottomBox">
                                    <div className="bgdanger w-100">
                                        <p>TOTAL</p>
                                        <h2>{schoolsCount}</h2>
                                    </div>
                                </div>
                            </div>
                            
                            <div 
                                className="boxdiv boxdivThree" 
                                style={{ cursor: 'pointer' }}
                                onClick={() => navigate('/view-schools-notifications', { 
                                    state: { 
                                        state: stateNames || localStorage.getItem("filterDataState") 
                                    } 
                                })}
                                onMouseEnter={(e) => {
                                    e.currentTarget.style.transform = 'scale(1.02)';
                                    e.currentTarget.style.transition = 'transform 0.2s ease-in-out';
                                }}
                                onMouseLeave={(e) => {
                                    e.currentTarget.style.transform = 'scale(1)';
                                }}
                            >
                                <div className="d-flex justify-content-between p-3">
                                    <div >
                                        <p>Total <span className="text-success w100">Notifications Uploaded</span></p>
                                    </div>
                                    <IoMdNotificationsOutline color="#9f4d9b " size={82}/>
                                </div>
                                <div className="d-flex justify-content-between bg-success bottomBox">
                                    <div className="bgdanger w-100">
                                        <p>TOTAL</p>
                                        <h2>{notificationCount}</h2>
                                    </div>
                                </div>
                            </div>
                            {/* <div className="boxdiv boxdivFour">
                                <div className="d-flex justify-content-between p-3">
                                    <div>
                                        <p>TOTAL UNIQUE <span className="text-success w100">BLOCKS/DISTRICTS</span></p>
                                    </div>
                                    <img src={WardIcon} alt="School Icon" style={{width:82, height:82}} />
                                </div>
                                <div className="d-flex justify-content-between bg-success bottomBox">
                                    <div className="bgdanger w-100">
                                        <p>TOTAL</p>
                                        <h2>{blockNames.length}</h2>
                                    </div>
                                </div>
                            </div> */}
                        </div>
                    </div>
                </Container>

                {/* District Table and Impact Section, always visible */}
                <Container>
                  <h4>District-wise Stats</h4>
                
                  <Table striped bordered hover>
                    <thead>
                      <tr>
                        <th>#</th>
                        <th>District</th>
                        <th>Saplings Planted</th>
                        <th>Total Schools</th>
                        {/* <th>Action</th> */}
                      </tr>
                    </thead>
                    <tbody>
                      {districtArray.map((item, idx) => (
                        <tr key={item.district}>
                          <td>{idx + 1}</td>
                          <td>{item.district}</td>
                          <td>{item.studentCount}</td>
                          <td>{item.totalSchools}</td>
                          {/* <td>
                            <Button
                              variant="info"
                              size="sm"
                              onClick={(e) => {e.preventDefault();navigate('/view-schools', { state: { district: item.district, state: statetopass}})} }
                            >
                              View Schools
                            </Button>
                          </td> */}
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </Container>

            </section >
        </>
    );
}

export default Ekpedmaakenaam;
